<script lang="ts">
  import Dark from '$lib/assets/logo.webp';
  import Light from '$lib/assets/logo-on-dark.webp';

  interface Props {
    onDark?: boolean;
    height?: string;
  }

  let { onDark = false, height = 'h-5' }: Props = $props();
</script>

<div class="{height} relative flex items-center justify-center">
  <div class="relative h-full">
    {#if onDark}
      <img src={Light} width="342" height="72" alt="Metri" class="mx-auto block h-full w-auto" />
    {:else}
      <img src={Dark} width="342" height="72" alt="Metri" class="mx-auto block h-full w-auto" />
    {/if}
  </div>
</div>
